/// <amd-module name="typeahead/features/HierarchicalSuggestion" />
/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../typings/typeahead/suggestionsProvider.d.ts"/>

import {Experiment} from "typeahead/core/Experiment";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {IEssSuggestionResult} from "typeahead/core/Suggestion";
import {PackageType, TypeaheadUtils} from "typeahead/core/TypeaheadUtils";
import {addFeatureFlag} from "typeahead/dataprovider/suggestservice/SuggestServiceQueryParamsUtils";

const configuration: IStripingConfiguration[] = [
    {
       lobs: ["HOTELS", "FLIGHTS", "RAILS", "PACKAGES"],
    },
];

const featureFlag = "ta_hierarchy";

export class HierarchicalSuggestion implements IExperimentalFeature, IRequestUrlParamModifier, ISuggestionsModifier {
    public getExperiments(): Experiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }

    public modifyParameters(params: ISuggestServiceQueryParams, context: IContext, options?: any):
            ISuggestServiceQueryParams {
        if (TypeaheadUtils.getPackageType() !== PackageType.FlightCar) {
            return addFeatureFlag(featureFlag, configuration, params, context, options);
        } else {
            return params;
        }
    }

    public modifySuggestions(suggestions: IEssSuggestionResult[], context: IContext, options: any): Object[] {
        if (suggestions && suggestions.length > 0) {
            suggestions.forEach((sugg: IEssSuggestionResult): void => {
                if (ExecutionHelper.shouldExecute(context, configuration)) {
                    let obj: string[] = sugg.relation;
                    if (+sugg.index > 0 && sugg.hierarchyInfo) {
                        obj = sugg.hierarchyInfo.relation;
                    }
                    if (obj && (obj[0] === "child" || obj[0] === "nearby")) {
                        // Set the flag to show as hierarchy option
                        sugg.showAsHierarchy = true;
                    }
                }
            });
        }
        return suggestions;
    }
}
